const cardItems = [
  {
    title: '选秀综艺暗流涌动：导师点评背后的故事',
    desc: '台前点评只是冰山一角，深扒三公录制现场导师之间的微妙互动与未播出片段。',
    tag: '选秀',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20TV%20studio%20with%20judges%20panel%20chairs%20and%20soft%20stage%20lighting%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20minimalist%20editorial%20composition%2C%20professional%20entertainment%20show%20aesthetic%2C%20clean%20background%20with%20subtle%20gradient%2C%20behind%20the%20scenes%20vibe&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '电竞赛场外的转会市场：夏季窗口大盘点',
    desc: '多家俱乐部启动重组谈判，三位明星选手合约即将到期，转会风向标全面解读。',
    tag: '电竞',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20esports%20team%20management%20office%20with%20abstract%20data%20visualization%20elements%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20minimalist%20editorial%20composition%2C%20professional%20sports%20business%20aesthetic%2C%20clean%20geometric%20background%20patterns&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '美食大赛评委内幕：评分标准到底怎么定',
    desc: '前评委匿名分享大赛评分体系，摆盘、创意、口味权重分配的行业潜规则大揭秘。',
    tag: '美食',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20gourmet%20kitchen%20with%20elegant%20plating%20setup%20and%20soft%20overhead%20lighting%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20minimalist%20editorial%20composition%2C%20professional%20food%20photography%20aesthetic%2C%20clean%20marble%20background&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: 'AI创作大赛争议升级：艺术与技术的边界在哪',
    desc: '获奖作品被质疑AI参与度过高，评审团紧急发布补充说明，行业规范亟待建立。',
    tag: '科技',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20digital%20art%20studio%20with%20abstract%20AI%20neural%20network%20patterns%20and%20creative%20tools%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20minimalist%20editorial%20composition%2C%20futuristic%20yet%20warm%20aesthetic%2C%20clean%20gradient%20background&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '街舞大赛选手生存现状：冠军之后的路',
    desc: '历届冠军赛后发展追踪，有人开工作室有人转战幕后，街舞选手的职业路径全解析。',
    tag: '街舞',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20dance%20studio%20interior%20with%20mirror%20walls%20and%20warm%20ambient%20lighting%2C%20coral%20and%20amber%20color%20scheme%2C%20minimalist%20editorial%20composition%2C%20professional%20dance%20culture%20aesthetic%2C%20clean%20modern%20interior%20design&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    title: '歌手2026选曲策略：哪些歌最容易拿高分',
    desc: '统计前五期高分选曲特征，情感爆发点、音域跨度与改编空间的选曲黄金公式。',
    tag: '音乐',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20music%20studio%20with%20sheet%20music%20and%20elegant%20acoustic%20instruments%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20minimalist%20editorial%20composition%2C%20professional%20music%20production%20aesthetic%2C%20soft%20atmospheric%20lighting&width=600&height=400&seq=card-06&orientation=landscape',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            热门吃瓜
          </h2>
          <p className="text-sm text-foreground-500 mt-2">大赛吃瓜热门内容精选，深度解读每一场精彩赛事</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item, i) => (
            <div key={i} className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden flex flex-col">
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-0.5 rounded-full bg-background-50/90 text-foreground-700 text-[11px] font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
                <div className="flex items-center gap-3 mt-4 pt-3 border-t border-background-200/60">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-eye-line mr-1"></i>2.3万
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-chat-1-line mr-1"></i>486
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}